import React, { useMemo } from 'react';
import { format } from 'date-fns';
import L from 'leaflet';
import { Marker, Popup } from 'react-leaflet';
import { ActingDetailPassengerEventResponse } from '@area-restrita/api-client/model/actingDetailPassengerEventResponse';

interface IProps {
  event: ActingDetailPassengerEventResponse;
}

const PassengerEventMarker: React.FC<IProps> = ({ event }) => {
  const isBoarding = event.kind === 'boarding';
  const icon = useMemo(
    () =>
      L.divIcon({
        className: '',
        iconAnchor: [18, 18],
        iconSize: [36, 36],
        html: `<span class="flex size-9 items-center justify-center rounded-full border-2 border-white text-xs font-bold text-white shadow-lg ${
          isBoarding ? 'bg-emerald-600' : 'bg-orange-600'
        }">${event.passengerCount}</span>`,
      }),
    [event.passengerCount, isBoarding],
  );

  return (
    <Marker position={[event.lat, event.lng]} icon={icon}>
      <Popup>
        <div className="min-w-44 space-y-1">
          <p className="font-semibold">
            {isBoarding ? 'Embarque' : 'Desembarque'}
          </p>
          <p>
            Variação: {event.delta > 0 ? '+' : ''}
            {event.delta}
          </p>
          <p>Lotação após o evento: {event.passengerCount}</p>
          <p>{format(new Date(event.measurementTime), 'dd/MM/yyyy HH:mm')}</p>
          <p className="text-xs text-muted-foreground">
            {event.lat.toFixed(6)}, {event.lng.toFixed(6)}
          </p>
        </div>
      </Popup>
    </Marker>
  );
};

export default PassengerEventMarker;
